import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24014f63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "back-ccc" }, null, -1))
const _hoisted_3 = { class: "btn-box" }

import { computed, onMounted, reactive,ref, watch } from "vue";
import type { UnwrapRef } from "vue";
import dayjs, { Dayjs } from 'dayjs';
import axios from 'axios';
import { message } from "ant-design-vue"
import type { FormInstance } from 'ant-design-vue';
import { extractUrlQueryParams } from '@/utils/index'
import MobileFooter from '@/components/mobileFooter.vue'
interface FormState {
  sex: string;
  name: string;
  phone: string;
  idCard: string;
  area: string;
  birthday: String;
}
interface IDCardInfo {
  isValid: boolean;
  birthDate: string; // 格式为 'YYYY-MM-DD'
  gender: '1' | '0';
}

// 枚举性别
enum Gender {
  Male = '1',
  Female = '0'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreMemberShipRegistration',
  setup(__props) {

const formState: UnwrapRef<FormState> = reactive({
  sex: '',
  name: "",
  phone: "",
  idCard: "",
  area: "",
  birthday: ""
});
const PHONE_PATTERN = /^1[3-9]\d{9}$/; // 手机号正则
const ID_CARD_PATTERN = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; // 身份证号正则（简单版）
const formRef = ref<FormInstance>()
const  preventKeyboard = (e:any) => {
      e.preventDefault(); // 阻止默认行为，可能包括键盘弹出
      e.stopPropagation(); // 阻止事件冒泡，以防其他处理函数触发键盘弹出
      // 或者尝试其他阻止键盘弹出的方法，如document.activeElement.blur()
    }
const bindRef = (ref:any) => {
  formRef.value = ref
}
const formItemLayout = computed(() => {
  return {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 },
  }
});

const submit = async () => {
  let birth = ''
  if(!formState.sex){
    message.error("请选择性别")
    return ;
  }
  if(!formState.name){
    message.error("请输入姓名")
    return ;
  }
  if(!formState.phone){
    message.error("请输入手机号")
    return ;
  }
  // if(!formState.idCard){
  //   message.error("请输入身份证号")
  //   return ;
  // }
  if(!PHONE_PATTERN.test(formState.phone)){
    message.error("请输入正确的手机号码！")
    return ;
  }
  if(formState.idCard && !ID_CARD_PATTERN.test(formState.idCard)){
    message.error("请输入正确的身份证号码！")
    return ;
  }
  // if(!formState.area){
  //   message.error("请输入详细地址")
  //   return ;
  // }
  // if(!formState.name){
  //   message.error("请输入出生年月")
  //   return ;
  // }
  if(formState.birthday){
    if(formState.birthday.length != 8 || isNaN(Number(formState.birthday))){
      message.error('出生日期格式不正确,示例：20240304')
      return 
    }
    let year,month,day;
    year = Number(formState.birthday.slice(0,4))
    month = Number(formState.birthday.slice(4,6))
    day = Number(formState.birthday.slice(6,8))
    if(year < 1900 || year > new Date().getFullYear()){
      message.error('出生日期格式不正确，请检查出生年份')
      return 
    }
    if(day > 31 || month > 12) {
      message.error('出生日期格式不正确，日期错误请检查')
      return 
    }

    birth = year + '-' + month + '-' + day
  }
  const params = extractUrlQueryParams(window.location.href);
  const postData = new FormData()
  postData.append("ticket", params.t)
  postData.append("modelData", JSON.stringify({
    Name: formState.name,
    Mobile: formState.phone,
    IdCard: formState.idCard,
    Birthday: birth,
    Sex: formState.sex,
    Address: formState.area,
  }))
  axios.post('https://api-erp.yaofangwang.com/common.handle.addShopCustomerForH5', postData)
    .then((response) => {
      if (response.data?.code == 1) {
        message.success("提交成功！")
      }
      else {
        message.error(response.data?.msg)
      }
    })
    .catch((error) => {
      message.error(error.message)
    });
}

function validateAndExtractIDCard(idCard: string): IDCardInfo {
  // 定义正则表达式用于验证18位和15位身份证号
  const idCard18Pattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dxX]$/;
  const idCard15Pattern = /^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$/;

  let result: IDCardInfo = { isValid: false , gender:'0',birthDate:'' };

  if (idCard18Pattern.test(idCard)) {
    // 18位身份证号
    result = {
      isValid: true,
      birthDate: `${idCard.slice(6, 10)}${idCard.slice(10, 12)}${idCard.slice(12, 14)}`,
      gender: parseInt(idCard.slice(16, 17), 10) % 2 === 0 ? Gender.Female : Gender.Male
    };
  } else if (idCard15Pattern.test(idCard)) {
    // 15位身份证号
    result = {
      isValid: true,
      birthDate: `19${idCard.slice(6, 8)}${idCard.slice(8, 10)}${idCard.slice(10, 12)}`,
      gender: parseInt(idCard.slice(14, 15), 10) % 2 === 0 ? Gender.Female : Gender.Male
    };
  }

  return result;
}

watch(() => formState.idCard, () => {
  
  const data = validateAndExtractIDCard(formState.idCard)
  if(data.isValid){
    formState.sex = data.gender;
    formState.birthday = data.birthDate;
  }
})
onMounted(() => {
  document.title = '会员注册'
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, _mergeProps({
      model: formState,
      layout: "horizontal"
    }, _unref(formItemLayout), {
      ref: bindRef,
      onSubmit: _withModifiers(submit, ["prevent"])
    }), {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "姓名",
          rules: [{ required: true, message: '请填写会员姓名' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formState.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.name) = $event)),
              placeholder: "请填写会员姓名"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "手机",
          rules: [{ required: true, message: '请填写会员手机' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formState.phone,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.phone) = $event)),
              placeholder: "请填写会员手机"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _hoisted_2,
        _createVNode(_component_a_form_item, { label: "身份证号" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formState.idCard,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.idCard) = $event)),
              placeholder: "请填写会员身份证号"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "性别",
          rules: [{ required: true, message: '请选择会员性别' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              value: formState.sex,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.sex) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, { value: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("男")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: "0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("女")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "出生年月（格式：20230504）" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formState.birthday,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.birthday) = $event)),
              placeholder: "请填写出生年月"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "详细地址" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formState.area,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.area) = $event)),
              placeholder: "请填写会员详细地址",
              class: "input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(MobileFooter),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            type: "primary",
            "html-type": "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 16, ["model", "onSubmit"])
  ]))
}
}

})